import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { ROOT } from '../../../../../store/utils/files-names';

export const getIsAppLoadingSelector = (state: AppRootState): boolean =>
  get(state, ROOT).isLoading;
